import { createFileRoute, redirect } from '@tanstack/react-router'
import SignupPage from '@/pages/signup'
import { localizeInternalPath } from '@/shared/i18n/localized-path'
import { isSignupOpen } from '@/shared/lib/hidden-public-pages'

interface SignupSearchParams {
  redirect?: string
}

export const Route = createFileRoute('/$lang/signup/')({
  validateSearch: (search: Record<string, unknown>): SignupSearchParams => ({
    redirect:
      typeof search.redirect === 'string' && search.redirect.startsWith('/')
        ? search.redirect
        : undefined,
  }),
  beforeLoad: ({ context, search, params }) => {
    // Public signup also preserves a protected destination through verification.
    if (!isSignupOpen(search.redirect)) {
      throw redirect({
        to: '/$lang/login',
        params: { lang: params.lang },
        search: search.redirect ? { redirect: search.redirect } : undefined,
        replace: true,
      })
    }
    if (context.auth.status === 'AUTHENTICATED') {
      const redirectTo = localizeInternalPath(search.redirect, params.lang)
      if (redirectTo) {
        throw redirect({ href: redirectTo })
      }
      throw redirect({
        to: '/$lang/app',
        params: { lang: params.lang },
      })
    }
  },
  component: SignupPage,
  staticData: { layout: 'public' },
})
